export * from './ArrowCollapseTrianglesVClosedIcon';
export * from './ArrowCollapseTrianglesVClosedIcon16Light';
export * from './ArrowCollapseTrianglesVClosedIcon16Regular';
export * from './ArrowCollapseTrianglesVClosedIcon16Solid';
export * from './ArrowCollapseTrianglesVClosedIcon20Light';
export * from './ArrowCollapseTrianglesVClosedIcon20Regular';
export * from './ArrowCollapseTrianglesVClosedIcon20Solid';
export * from './ArrowCollapseTrianglesVClosedIcon24Regular';
export * from './ArrowCollapseTrianglesVClosedIcon24Solid';
export * from './ArrowCollapseTrianglesVClosedIcon32Regular';
export * from './ArrowCollapseTrianglesVClosedIcon64Regular';
